<template>
  <component :is="layout"></component>
</template>

<script>
import tmplDefault from '@/templates/default/contents/content-detail'
import tmplCanalSur from '@/templates/canal-sur/contents/content-detail'

export default {
  name: 'ContentDetail',
  components: {
    'tmpl-DFT': tmplDefault, // defecto
    // 'tmpl-PIN': tmplPinkoTV, // Pinko TV
    // 'tmpl-PLN': tmplPlay, // Play
    // 'tmpl-PLY': tmplPlayTrailer, // Play + trailer
    // 'tmpl-APP': tmplApple, // Apple
    'tmpl-SUR': tmplCanalSur // Canal Sur
  },
  beforeCreate: function () {
    document.querySelector('body').style.overflowY = 'hidden'
  },
  computed: {
    layout () {
      let layout = 'tmpl-' + this.$store.getters.getData.template5
      return this.$options.components[layout] ? layout : 'tmpl-DFT'
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/contents/ContentDetail.vue